import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import { StepContext } from '../../../../../creator/step.context';
import { useWindowResize } from '../../../../../../../helpers/effects/useWindowResize';
import { scrollToElementById } from '../../../../../../../helpers';
import styles from './styles.module.scss';

export const FocusedSheet: FC = () => {
    const isMobile = useIsMobile();
    const { focusedField, setFocusedField, currentStepConfig } = useContext(StepContext);
    const prevWidth = useRef(window.visualViewport?.width);
    const prevFocusedField = useRef(focusedField);
    const [viewportHeight, setViewportHeight] = useState(window.visualViewport?.height);

    useEffect(() => {
        prevWidth.current = window.visualViewport?.width;
        setViewportHeight(window.visualViewport?.height);
    }, []);

    useEffect(() => {
        const prevFocused = prevFocusedField.current;
        if (!focusedField && prevFocused) {
            scrollToElementById(`field_${prevFocused}`, 'auto');
            prevFocusedField.current = null;
        } else {
            prevFocusedField.current = focusedField;
        }
    }, [focusedField]);

    const blurActiveFieldOnScreenChange = () => {
        const activeElementName = document.activeElement ? (document.activeElement as any).name : undefined;
        if (activeElementName) {
            (document.activeElement as any).blur();
        }
    };

    useWindowResize(
        ({ innerHeight, innerWidth }) => {
            if (prevWidth.current !== innerWidth) {
                blurActiveFieldOnScreenChange();
                prevWidth.current = innerWidth;
            }
            setViewportHeight(innerHeight);
        },
        [],
        true,
    );

    useEffect(() => {
        if (!isMobile) {
            setFocusedField(null);
        }
    }, [isMobile]);

    return (
        <div
            className={cn(styles['focused-sheet'], { [styles['focused-sheet_hidden']]: !focusedField })}
            style={{ height: `${viewportHeight}px` }}>
            <div className={styles['focused-sheet__content']}>{<currentStepConfig.SheetView />}</div>
        </div>
    );
};
